import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, CheckCircle } from 'lucide-react';
import ClassWizardSteps from './ClassWizardSteps';

interface ClassWizardLayoutProps {
  children: ReactNode;
  currentStep: number;
  title: string;
  description: string;
  onNext?: () => void;
  onBack?: () => void;
  nextDisabled?: boolean;
  nextLabel?: string;
  showBackButton?: boolean;
}

const ClassWizardLayout = ({
  children,
  currentStep,
  title,
  description,
  onNext,
  onBack,
  nextDisabled = false,
  nextLabel = 'Próximo',
  showBackButton = true,
}: ClassWizardLayoutProps) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else if (currentStep > 1) {
      navigate(`/class-wizard/step${currentStep - 1}`);
    } else {
      navigate('/classes');
    }
  };

  return (
    <div className="w-full p-6">
      <div className="mb-6">
        <div className="flex flex-col space-y-1.5">
          <h2 className="text-xl font-extrabold">{title}</h2>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
      </div>

      <div className="mb-8 mt-4">
        <ClassWizardSteps currentStep={currentStep} />
      </div>

      <div className="space-y-8">
        {children}

        <div className="flex justify-between pt-4 border-t">
          {showBackButton && (
            <Button
              variant="outline"
              onClick={handleBack}
              className="gap-1"
            >
              <ArrowLeft className="h-4 w-4" />
              Voltar
            </Button>
          )}
          {onNext && (
            <Button
              onClick={onNext}
              disabled={nextDisabled}
              className="ml-auto gap-1"
            >
              {nextLabel}
              {currentStep === 5 && <CheckCircle className="h-4 w-4 ml-1" />}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClassWizardLayout; 